import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={72}
      height={48}
      viewBox="0 0 72 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={1} y={1} width={70} height={46} fill="#DEDFE4" />
      <rect
        x={1}
        y={1}
        width={70}
        height={46}
        stroke="#1E354E"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={1}
        y={1}
        width={70}
        height={46}
        stroke="#0B1642"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.1812H64"
        stroke="#1E354E"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.1812H64"
        stroke="#0B1642"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 16.1812H64"
        stroke="#1E354E"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 16.1812H64"
        stroke="#0B1642"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 22.1812H38"
        stroke="#1E354E"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 22.1812H38"
        stroke="#0B1642"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 38H28"
        stroke="#1E354E"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 38H28"
        stroke="#0B1642"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45 38H64"
        stroke="#1E354E"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45 38H64"
        stroke="#0B1642"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.2285 34.1812C50.2518 33.2078 53.0913 32.0064 53.0834 29.5707C53.0788 28.1285 51.1548 27.501 50.3346 28.6872C49.2969 30.1882 49.9107 32.1717 52.3689 33.8436C52.7055 34.0725 53.1172 34.1728 53.5209 34.1206C54.8601 33.9473 55.5717 33.5215 56.3659 32.4552C56.5663 32.1863 56.9503 32.1247 57.2104 32.3364L58.6204 33.4834C58.9225 33.729 59.3491 33.7321 59.6796 33.5263C60.2993 33.1405 60.8943 32.9203 61.5435 32.9212"
        stroke="#1E354E"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.2285 34.1812C50.2518 33.2078 53.0913 32.0064 53.0834 29.5707C53.0788 28.1285 51.1548 27.501 50.3346 28.6872C49.2969 30.1882 49.9107 32.1717 52.3689 33.8436C52.7055 34.0725 53.1172 34.1728 53.5209 34.1206C54.8601 33.9473 55.5717 33.5215 56.3659 32.4552C56.5663 32.1863 56.9503 32.1247 57.2104 32.3364L58.6204 33.4834C58.9225 33.729 59.3491 33.7321 59.6796 33.5263C60.2993 33.1405 60.8943 32.9203 61.5435 32.9212"
        stroke="#0B1642"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-ecp" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
